import { useMemo } from 'react';

import { ALTERNATIVES, PLASTICS } from '../Data';
import { Item } from '../Types';

interface Params {
    items: Item[];
    type: 'initial' | 'final' | 'saving';
}

const useCo2Calculation = (params: Params) => {
    const { items, type } = params;

    return useMemo(() => {
        return items.reduce((prev, data) => {
            const plastic = PLASTICS.find(p => p.name === data.plastic);
            const alternative = ALTERNATIVES.find(a => a.name === data.alternative);

            let value = 0;

            if (plastic && type !== 'final') {
                value += plastic.value * data.amount;
            }

            if (alternative && type !== 'initial') {
                value += alternative.value * data.amount * (type === 'saving' ? -1 : 1);
            }

            return prev + value;
        }, 0.0);
    }, [items, type]);
};

export default useCo2Calculation;